import { referenceDataFeature } from '../reducers/reference-data.reducers';

export const selectAllYearOfStudy = referenceDataFeature.selectYearOfStudy;

export const selectAllEstablishments = referenceDataFeature.selectEstablishments;
